import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "invalid-feedback",
  role: "alert"
}

import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

import {computed, onMounted, ref, toRef} from "vue";


export default /*@__PURE__*/_defineComponent({
  ...{
    inheritAttrs: false,
},
  __name: 'DatePicker',
  props: /*@__PURE__*/_mergeModels({
    error: {
        type: String,
        default: null,
    },
    monthPicker: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    autoApply: {
        type: Boolean,
        default: true,
    },
    enableTimePicker: {
        type: Boolean,
        default: false,
    },
    enableMinutes: {
        type: Boolean,
        default: true,
    },
    enableSeconds: {
        type: Boolean,
        default: false,
    },
    maxDate: {
        type: Date,
        default: undefined
    },
    autoPosition: {
        type: Boolean,
        default: true,
    },
    minDate: {
        type: Date,
        default: undefined
    }
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

const dateFormat = computed(() => {
    let format = "yyyy-MM-dd";
    
    if(props.monthPicker){
        format = "MM-yyyy";
    }

    if(props.enableTimePicker){
        if(props.enableSeconds){
            format = "yyyy-MM-dd HH:mm:ss";
        }
        else{
            format = "yyyy-MM-dd HH:mm";
        }
    }
    return format;
});

const model = _useModel(__props, "modelValue");

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Datepicker), {
      format: dateFormat.value,
      modelValue: model.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
      clearable: false,
      "month-picker": props.monthPicker,
      "auto-apply": props.autoApply,
      utc: true,
      class: _normalizeClass({'is-invalid': !!__props.error}),
      "enable-time-picker": props.enableTimePicker,
      "enable-minutes": props.enableMinutes,
      "enable-seconds": props.enableSeconds,
      "input-class-name": !!__props.error ? 'form-control is-invalid' : 'form-control',
      ui: {input: !!__props.error ? 'form-control is-invalid' : 'form-control'},
      "max-date": props.maxDate,
      "min-date": props.minDate,
      "auto-position": props.autoPosition
    }, null, 8, ["format", "modelValue", "month-picker", "auto-apply", "class", "enable-time-picker", "enable-minutes", "enable-seconds", "input-class-name", "ui", "max-date", "min-date", "auto-position"]),
    (__props.error)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.error), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})